import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { myAccountService } from './myAccounts.service';
import { handleThunkError } from '../helpers/thunkError';

const initialState = {
  myAccounts: [],
  myAccountHoldings: null,
  loadingMyAccounts: false,
  loadingMyAccountHoldings: false,
  error: null
};

// --- GET MY ACCOUNTS ---
export const getMyAccounts = createAsyncThunk(
  'myAccounts/getMyAccounts',
  async ({ asof }, thunkAPI) => {
    try {
      return await myAccountService.getMyAccounts({ asof });
    } catch (error) {
      return handleThunkError(error, thunkAPI, 'Failed to fetch my accounts');
    }
  }
);

// --- GET MY ACCOUNT HOLDINGS ---
export const getMyAccountHoldings = createAsyncThunk(
  'myAccounts/getMyAccountHoldings',
  async ({ id, asof }, thunkAPI) => {
    try {
      return await myAccountService.getMyAccountHoldings({ id, asof });
    } catch (error) {
      return handleThunkError(error, thunkAPI, 'Failed to fetch my account holdings');
    }
  }
);

const myAccountSlice = createSlice({
  name: 'myAccounts',
  initialState,
  reducers: {
    clearMyAccounts: (state) => {
      state.myAccounts = [];
      state.myAccountHoldings = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // MY ACCOUNTS
      .addCase(getMyAccounts.pending, (state) => {
        state.loadingMyAccounts = true;
        state.error = null;
      })
      .addCase(getMyAccounts.fulfilled, (state, action) => {
        state.loadingMyAccounts = false;
        state.myAccounts = action.payload;
      })
      .addCase(getMyAccounts.rejected, (state, action) => {
        state.loadingMyAccounts = false;
        state.error = action.payload;
      })

      // MY ACCOUNT HOLDINGS
      .addCase(getMyAccountHoldings.pending, (state) => {
        state.loadingMyAccountHoldings = true;
      })
      .addCase(getMyAccountHoldings.fulfilled, (state, action) => {
        state.loadingMyAccountHoldings = false;
        state.myAccountHoldings = action.payload;
      })
      .addCase(getMyAccountHoldings.rejected, (state, action) => {
        state.loadingMyAccountHoldings = false;
        state.error = action.payload;
      });
  }
});

export const { clearMyAccounts } = myAccountSlice.actions;
export default myAccountSlice.reducer;
